import dynamic from 'next/dynamic';
import { SessionTimeoutProps } from './SessionTimeoutModal.types';

export const SessionTimeoutModal = dynamic<SessionTimeoutProps>(() =>
  import('./SessionTimeoutModal').then(module => module.SessionTimeoutModal)
);
